<template>
  <div class="link-info">
    <b-badge pill variant="primary">
      {{info}}
    </b-badge>
  </div>
</template>
<script>

import {Steps} from '../../../core/services/steps.js'

export default {
  name: 'LinkInfo',
  props: ['info'],
  data() {
    return {
      stepList: Steps
    };
  },
  methods: {
  }
};
</script>

<style scoped>
.link-info .badge {
  font-size: 1.5em;
  z-index: 10;
}
</style>


// WEBPACK FOOTER //
// src/components/andon/detailed/LinkInfo.vue